/*
 eslint no-param-reassign: ["error", { "props": false }], array-callback-return: "off",
 no-unused-expressions: "off", no-case-declarations: "off"
 */

import flattenSize, { toArray } from './size-facet-helper';
import priceFacetAdaptor from './price-facet-adapter/index';
import withFacetConfig from '../../left-faceted-grid/adapters/with-facet-config';
import getSizeVariants from './size-variants';
import adaptGenericFacet, { allOptionsIsInactive } from './generic-facet-adapter';
import facetsHiddenByConfiguration from './flex-facets-adapter/facets-hidden-by-configuration';

const transformFacetsSize = (facet, facets) => {
  const transformedSize = flattenSize(facet);
  const sizeVariants = getSizeVariants(transformedSize);

  if (sizeVariants.length > 0) {
    facets.size = { ...facet, type: 'complex', sizeVariants };
  }
};

const transformAppliedFacetsSize = (facet, appliedFacets) => {
  const transformedSize = flattenSize(facet);

  if (transformedSize.selectedSizes && transformedSize.selectedSizes.length > 0) {
    appliedFacets.size = transformedSize.selectedSizes;
  }
};

const transformColor = (facet, facets, appliedFacets) => {
  const { facet: colorFacet, appliedValues } = adaptGenericFacet(facet);

  facets.color = colorFacet ? { ...colorFacet } : undefined;
  appliedFacets.color = appliedValues;
};

const transformStyle = (facet, facets, appliedFacets) => {
  const { facet: styleFacet, appliedValues } = adaptGenericFacet(facet);

  facets.style = styleFacet ? { ...styleFacet } : undefined;
  appliedFacets.style = appliedValues;
};

const transformDepartment = (facet, facets, appliedFacets) => {
  const { facet: departmentFacet, appliedValues } = adaptGenericFacet(
    facet
  );

  facets.department = departmentFacet ? { ...departmentFacet } : undefined;
  appliedFacets.department = appliedValues;
};

const transformRatings = (facet, facets, appliedFacets) => {
  const { facet: ratingsFacet, appliedValues } = adaptGenericFacet(facet);
  const isFacetAvailable = ratingsFacet && !allOptionsIsInactive(ratingsFacet.options);
  facets.reviewScore = isFacetAvailable ? { ...ratingsFacet } : undefined;
  appliedFacets.reviewScore = appliedValues;
};

const transformPrice = (facet, facets, appliedFacets) => {
  const adaptedFacet = priceFacetAdaptor(facet, appliedFacets);
  facets.price = adaptedFacet;
  if (adaptedFacet.hasTags) {
    appliedFacets.price.push(adaptedFacet);
  }
};

const facetTransformations = {
  color: (facet, facets, appliedFacets) => transformColor(facet, facets, appliedFacets),
  department: (facet, facets, appliedFacets) => transformDepartment(facet, facets, appliedFacets),
  reviewScore: (facet, facets, appliedFacets) => transformRatings(facet, facets, appliedFacets),
  price: (facet, facets, appliedFacets) => transformPrice(facet, facets, appliedFacets),
  size: (facet, facets, appliedFacets) => {
    transformFacetsSize(facet, facets);
    transformAppliedFacetsSize(facet, appliedFacets);
  },
  style: (facet, facets, appliedFacets) => transformStyle(facet, facets, appliedFacets),
};

export default (data, hideDepartmentFacet, hidePriceFacet, hideRatingsFacet) => {
  const facets = {};
  const appliedFacets = {};

  if (data.productCategoryFacetedSearch.searchFacetInfo) {
    const facetsResponse = toArray(
      data.productCategoryFacetedSearch.searchFacetInfo.searchFacetList
    );

    facetsResponse
      .map(facet => ({ ...facet, name: facet.searchFacetId }))
      .filter(facetsHiddenByConfiguration(
        hideDepartmentFacet,
        hidePriceFacet,
        hideRatingsFacet,
      ))
      .forEach(facet => {
        appliedFacets[facet.searchFacetId] = [];
        const facetTransformationFn = facetTransformations[facet.searchFacetId];
        if (facetTransformationFn) facetTransformationFn(facet, facets, appliedFacets);
      });
  }

  const hasTags = Object.keys(appliedFacets)
    .map(name => appliedFacets[name])
    .some(applied => applied.length > 0);

  const facetOptions = [
    facets.department,
    facets.style,
    facets.size,
    facets.color,
    facets.price,
    facets.reviewScore,
  ]
    .filter(adaptedData => !!adaptedData)
    .map(withFacetConfig);

  const numFacets = facetOptions.length;

  return {
    hasTags,
    numFacets,
    facetOptions,
    appliedFacets,
  };
};